import React from "react";
import userIcon from "../../assets/images/user.svg";
import Avatar from "react-avatar";
import $ from "jquery";
import { useDispatch, useSelector } from "react-redux";
import { unreadVoiceChat, triggerVoiceChatPush } from "../../redux/action";
import { encodePhoneNumber } from "../../helpers/Utils";
import { Box } from "@chakra-ui/react";

export default function VoicemailContainerHeader({ voicemails }) {
  const dispatch = useDispatch();

  const handleUnread = async () => {
    let { chat_phone_no: phone_no } = voicemails;
    if (phone_no) {
      dispatch(unreadVoiceChat(phone_no));
      dispatch(triggerVoiceChatPush());
    }
  };
  const handleBackBtn = () => {
    $("#voicemail-list").css("display", "block");
    $("#single-voicemail").css("display", "none");
  };
  const userSelectedFont = useSelector((state) => state.settings.fontsize);
  return (
    <div className="details d-flex justify-content-between align-items-center">
      <div className="d-flex align-items-center">
        <i
          onClick={handleBackBtn}
          id="backBtn"
          className="fa-solid fa-chevron-left me-2 mobile-display"></i>
        {/*<img src={userIcon}/>*/}
        <Avatar
          size={
            userSelectedFont === "small"
              ? 28
              : userSelectedFont === "medium"
              ? 30
              : userSelectedFont === "large"
              ? 35
              : 35
          }
          name={
            voicemails.chat_data.length > 0 && voicemails.chat_data[0].full_name
              ? voicemails.chat_data[0].full_name
              : "U k"
          }
          round
        />

        <Box
          fontSize={
            userSelectedFont === "small"
              ? "14px"
              : userSelectedFont === "medium"
              ? "16px"
              : userSelectedFont === "large"
              ? "18px"
              : "18px"
          }
          className="user-name ms-2">
          {voicemails.chat_data.length > 0 && voicemails.chat_data[0].full_name
            ? voicemails.chat_data[0].full_name
            : ""}
        </Box>
        <button
          style={{
            fontSize:
              userSelectedFont === "small"
                ? "11px"
                : userSelectedFont === "medium"
                ? "13px"
                : userSelectedFont === "large"
                ? "16px"
                : "16px",
          }}
          className="contact-btn ms-2">
          {voicemails.chat_data.length > 0 &&
          voicemails.chat_data[0].sender_phone
            ? encodePhoneNumber(voicemails.chat_data[0].sender_phone)
            : ""}
        </button>
      </div>
      <div className="d-flex">
        <button
          className="primary-btn ms-2"
          data-bs-toggle="dropdown"
          aria-expanded="false">
          Action <i className="fa-solid fa-ellipsis-vertical ms-2"></i>
        </button>
        <ul className="dropdown-menu dropdown-menu-end">
          <li>
            <a
              className="dropdown-item"
              data-bs-toggle="modal"
              data-bs-target="#deleteVoiceMail">
              Delete
            </a>
          </li>
          <li onClick={handleUnread}>
            <a className="dropdown-item">Unread</a>
          </li>

          {voicemails.chat_data.length > 0 &&
            !voicemails.chat_data[0].full_name && (
              <li>
                <a
                  className="dropdown-item"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#createContactCanvas"
                  aria-controls="createContactCanvas">
                  {" "}
                  Add To Contacts{" "}
                </a>
              </li>
            )}
          <li>
            <a
              data-bs-toggle="offcanvas"
              data-bs-target="#sendMessageCanvas"
              aria-controls="sendMessageCanvas"
              className="dropdown-item">
              Send Message
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
}
